import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

/** Estado liviano de la credencial PJUD (sin contraseña), para el aviso de clave vencida. */
export interface PjudCredentialStatus {
  status: 'active' | 'expired' | 'missing' | 'unknown';
  credentials?: Array<{
    rut: string | null;
    authMethod: 'clave_unica' | 'clave_pj';
    status: string;
    expiredAt?: string | null;
    expiredReason?: string | null;
  }>;
}

/** Respuesta del endpoint de acceso: permiso + estado de credencial (si allowed). */
export interface PjudAccessInfo {
  allowed: boolean;
  credential?: PjudCredentialStatus;
}

/**
 * ACL del tablero PJUD: GET /trackvision/pjud/indicators/access
 * (pjud.visible en algún flujo + permiso flows.menu.pjud.indicators).
 * Devuelve además el estado liviano de la credencial PJUD (clave vencida) para
 * que la pantalla inicial de Flows muestre el aviso sin traer el payload pesado.
 */
@Injectable({ providedIn: 'root' })
export class PjudIndicatorsAccessService {
  constructor(private http: HttpClient) {}

  /** Solo el flag de permiso (compat: usos previos esperan boolean). */
  canAccess(): Observable<boolean> {
    return this.getAccessInfo().pipe(map((info) => info.allowed));
  }

  /** Permiso + estado de credencial en una sola llamada liviana. */
  getAccessInfo(): Observable<PjudAccessInfo> {
    const token = localStorage.getItem('access_token') || '';
    if (!token) {
      return of({ allowed: false });
    }

    return this.http
      .get(`${environment.apiUrl}/trackvision/pjud/indicators/access`, {
        headers: new HttpHeaders().set('Token', token),
      })
      .pipe(
        map((data: any) => {
          const payload = data?.result != null ? data.result : data;
          return {
            allowed: !!payload?.allowed,
            credential: payload?.credential,
          } as PjudAccessInfo;
        }),
        catchError(() => of({ allowed: false } as PjudAccessInfo))
      );
  }

  /** Reservado por si en el futuro se cachea de nuevo tras login/logout. */
  resetCache(): void {
    // sin cache en memoria: cada consulta va al API
  }
}
